<template>
    <DxPopup @hidden="onHidden" :visible="showHycot102Pop" :show-close-button="true" :show-title="true" :title="''"
        width="830" min-height="800" max-height="800" :container="container" :resizeEnabled="true">
        <v-row no-gutters class="epms1020_acc-main">
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle" :useBtnList="['btnSearch','btnAdd']" 
                    @btnSearch="btnSearch()" @btnAdd="btnCreateBill()">
                    <template v-slot:body>
                        <v-row no-gutters>
                            <i-label :label="'Insert Date : '" />
                              <v-col cols="2">
                                <DxDateBox
                                  :value="startDate"
                                  height="30px"
                                  display-format="yyyy-MM-dd"
                                  :acceptCustomValue="false"
                                  @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }"
                                />
                              </v-col>
                              <span class="pa-1 subTitle"> ~ </span>
                              <v-col cols="2">
                                <DxDateBox
                                  :value="endDate"                                                                    
                                  height="30px"
                                  display-format="yyyy-MM-dd"
                                  :acceptCustomValue="false"
                                  @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }"
                                />
                              </v-col>
                              <i-label :label="'B/L No : '" class="pl-2"/>
                              <v-col cols="2">
                                <v-text-field class="popField" 
                                  dense 
                                  outlined 
                                  hide-details="auto"
                                  clearable 
                                  maxLength="30"
                                  v-model="blNo"
                                  @keyup="uppercase"
                                  @keydown.enter="btnSearch()"
                                />
                              </v-col>
                        </v-row>
                                               
                        <v-row no-gutters class="pt-1">
                            <v-col cols="12">
                                <DxDataGrid id="hycot102Pop" :ref="hycot102PopRef" :height="650"
                                    :data-source="gridMainList" :remote-operations="false" :hover-state-enabled="true"
                                    :allow-column-resizing="true" :allow-column-reordering="true"
                                    :row-alternation-enabled="true" :show-borders="true" :width="grid.width"
                                    :show-row-lines="true" key-expr="id" :focused-row-enabled="false"
                                    :column-hiding-enabled="false" :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }">                                   
                                    <DxPaging :enabled="true" :page-size="18" />
                                    <DxPager :allowed-page-sizes="[18, 'all']" />

                                    <DxColumn data-field="selChek" data-type="boolean" width="10%" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
    									<template #selHeader = "{ data: cellInfo }" >
    										<DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                                        </template>
                                        <template #selChkRow = "{ data: cellInfo }">
                                            <DxCheckBox :value="cellInfo.value"  
                                                        :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                                        </template>
                                   
                                    <DxColumn caption="Bill of Lading" data-field="blNo" data-type="String" width="70%" alignment="center"
                                        :allow-editing="false" />  
                                    
                                    <DxColumn caption="R Ton" data-field="rton" data-type="number" format="#,###.###" width="20%" alignment="right"
                                    :allow-editing="true" /> 
                                   
                                </DxDataGrid>
                            </v-col>
                        </v-row>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getPopUpList } from '@/api/view/hycot/1/hycot102'
import iButton from '@/components/common/iButton'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import notify from 'devextreme/ui/notify'
import { makeNewBill } from '@/api/view/hycot/1/hycot102.js'

export default {
    name: 'hycot102Popup',
    mixins: [baseview, BaseDataGrid],
    components: {
        DxPopup,
        iButton,
        DxDateBox
    },
    props: {
        container: {
            type: String,
            default() {
                return '.v-application'
            }
        },
        showHycot102Pop: {
            type: Boolean,
            default() {
                return false
            }
        },

        invNo: {
            type: String,
            default() {
                return ''
            }
        }

    },
    data() {
        return {
            hycot102PopRef: 'hycot102PopRef',
            format: '#,##0.############',
            gridMainList: [],           
            makerCd: this.$store.state.user.makerCd,
            menuTitle: '',
            startDate: '',
            endDate: '',
            stDte: '',
            edDte: '',
            blNo:  ''            
        }
    },
    computed: {
        gridInstance() {
            return this.GetDataGrid(this.hycot102PopRef)
        }
    },
    watch: {
        'showHycot102Pop': {
            handler(value, oldValue) {
                if (value) {                    
                    this.btnSearch()
                } else {
                    this.blNo = ''
                }
            },
            immediate: true
        },
         'invNo': {
            handler(value, oldValue) {
                if (value) {
                    this.menuTitle = "Invoice No : " + value
                }
            }
        }
    },
    methods: {
        uppercase() {            
            if (this.blNo != '') {
                this.blNo = this.blNo.toUpperCase()
                console.log(this.blNo)
            }
        },
         getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        init() {
             var date = new Date();

            this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
            this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            this.gridMainList = []           
        },
        async onValueChanged(value, cellInfo) {
            console.log(this.gridMainList)
            if (cellInfo.rowType === 'header') {
                for (let i = 0; i < this.gridMainList.length; i++) {                    
                    this.gridMainList[i].selChek = value.value
                    if (value.value) {
                        this.gridInstance.selectRows(i + 1, true)
                        this.gridMainList[i].selChek = true
                    } else {
                        this.gridInstance.deselectAll()
                        this.gridMainList[i].selChek = false
                    }                    
                }
                this.gridInstance.updateDimensions()
                 
            } else {
                this.gridMainList[cellInfo.rowIndex].selChek = value.value
                if (value.value) {
                    console.log('row', cellInfo.rowIndex + 1)
                    this.gridInstance.selectRows([cellInfo.rowIndex + 1], true)
                } else {
                    this.gridInstance.deselectRows([cellInfo.rowIndex + 1])
                }               

                this.gridInstance.updateDimensions()
             }
             
        },

        btnSearch() {
            this.init()

            const param = {
                newBl: !this.blNo ? '' : this.blNo,
                stDte: this.stDte,
                edDte: this.edDte,
                invNo: this.invNo
            }
             console.log('param', param)

            getPopUpList(param).then(res => {
                let cnt = 1
                  res.list.forEach(e => {
                      e.id  = cnt++                      
                      e.selChek = false
                });
                this.gridMainList = res.list                
            })            
        },
        
         btnCreateBill(data) {
            this.vToastifyPrompt(
                this.$t(`Are you sure to add new bill?`),
                'info',
                async current => {
                    this.openLoading('searching')

                     let param = []
                    
                    if (this.gridMainList.length > 0) {
                        await this.gridInstance.saveEditData()
                        var selectedMainRows = await this.gridInstance.getSelectedRowsData()
                        console.log('selectedMainRows', selectedMainRows)
                        if (!selectedMainRows.length) {
                            this.vToastify(this.$t('Data is not selected.'), 'warn')
                            return
                        }else {
                            const hasEmptyRTon = selectedMainRows.some(row => {
                                return row.rton === undefined || row.rton === null || String(row.rton).trim() === '';
                                });

                                if (hasEmptyRTon) {                               
                                    this.vToastify(this.$t('Please input R Ton before Add!.'), 'warn')
                                    return 
                                }
                        }                                              
                        
                        for (let i = 0; i < selectedMainRows.length; i++) {
                            param.push({
                                makerCd: this.$store.state.user.makerCd,
                                invNo: this.invNo,
                                newBl: selectedMainRows[i].blNo,
                                rton : selectedMainRows[i].rton
                            })
                        }
                    }
                    
                    console.log('param : ', param)
                    
                    makeNewBill(param).then(res => {
                         console.log('res', res)
                        if (res.body === 'OK') {
                            notify(this.$t('Bill No is created.'), 'success', 3000)
                                                      
                        } else {
                            this.vToastify(this.$t("An error has occured while saving data...."), 'warn')
                        }
                    }).catch(error => {
                        this.vToastify(error, 'warn')
                    }).finally(() => {
                         this.$emit('saveBl')
                        this.btnSearch()
                        this.endLoading()
                    })
                },
                null,
                true
            )
        },
        onHidden(e) {
            this.$emit('update:showHycot102Pop', false)
            //this.showHycot102Pop = false
        }
    },
    mounted() {
        var date = new Date();

        this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);    

        this.gridInstance.option('defaultPaging', false)
    }
}
</script>

<style lang="scss" scoped>
.subTitle {
    font-weight: bold;
    color: black;
}

.form-layout::v-deep>.col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;

    .row {
        border-width: 0 0 1px 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }

    .col {
        border-width: 0 1px 0 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }
}

.formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    color: black;
    font-size: 9pt;
}

.formData {
    color: black;
}

::v-deep.qty-text {
    input {
        text-align: right;
    }
}
</style>